import axiosInstance from "src/config/axiosInstance";

class AIGenerationService {
    static async generateContent(payload) {
        try {
            const response = await axiosInstance.post(
                "/ai/generate-content",
                payload,
            );

            return response.data;
        } catch (error) {
            console.error("Error generating AI content:", error);
            throw error;
        }
    }
}

export default AIGenerationService;
